import { Navigate } from 'react-router-dom';

import useAuthStore from '@entities/auth/model/useAuthStore';

/**
 * AppProtectedRoute
 * - shared/ProtectedRoute를 수정하지 않고, app 레벨에서 인증 가드를 적용하기 위한 래퍼
 * - 버그 원인: sessionStorage 키 체크가 환경/타이밍에 따라 어긋나면 /login ↔ /approval/* 리다이렉트 루프가 발생할 수 있음
 */
export default function AppProtectedRoute({ children }) {
  const token = useAuthStore((state) => state.token);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
